// not from runtime
export const IsWhiteLabel = () =>
  process.env.REACT_APP_IS_WHITE_LABEL === "true";
export const IsYaMetricEnabled = () =>
  process.env.REACT_APP_YA_METRIC === "true";

// from runtime
export let RuntimeConfig: any = {};
export const SHOULD_USE_KEYCLOAK_AUTH = (): boolean =>
  RuntimeConfig.APP_KEYCLOAK_AUTH_ENABLED;
export const IsConsolidationEnabled = (): boolean =>
  RuntimeConfig.APP_CONSOLIDATION_ENABLED === true;
export const IsSupportChatEnabled = (): boolean =>
  RuntimeConfig.APP_SUPPORT_CHAT_ENABLED === true;
export const ShouldHideHelp = (): boolean =>
  RuntimeConfig.APP_HIDE_HELP === true;
export const IsStandaloneDocsEnabled = (): boolean =>
  RuntimeConfig.APP_STANDALONE_DOCS_ENABLED === true;

// !!!для обратной совместимости, где в конфиге только APP_CREDIT_RATING используется APP_CREDIT_RATING
export const IsCreditRatingAvers = () => RuntimeConfig.APP_CREDIT_RATING === "AVERS" || RuntimeConfig.APP_CREDIT_RATING === "rating_avx";
export const IsCreditRatingSDM = () => RuntimeConfig.APP_CREDIT_RATING === "SDM" || RuntimeConfig.APP_CREDIT_RATING === "rating_sdmx";

export const IsCreditOpinionAvers = () => {
  const opinion = RuntimeConfig.APP_CREDIT_OPINION;
  return !opinion ? RuntimeConfig.APP_CREDIT_RATING === "AVERS" : opinion === "credit_opinion_avx";
};
export const IsCreditOpinionSDM = () => {
  const opinion = RuntimeConfig.APP_CREDIT_OPINION;
  return !opinion ? RuntimeConfig.APP_CREDIT_RATING === "SDM" : opinion === "credit_opinion_sdmx";
};
export const IsCreditOpinionCreditAnalysis = () => {
  const opinion = RuntimeConfig.APP_CREDIT_OPINION;
  return !opinion ? RuntimeConfig.APP_CREDIT_RATING === "CREDIT_ANALYSIS" : opinion === "credit_opinion_fsx";
};
export const IsCreditOpinionNBD = () => RuntimeConfig.APP_CREDIT_OPINION === "credit_opinion_nbdx";

export const IsProfJudgmentAvers = () => {
  const judgment = RuntimeConfig.APP_PROF_JUDGMENT;
  return !judgment ? RuntimeConfig.APP_CREDIT_RATING === "AVERS" : judgment === "prof_judgment_avx";
};

export const IsProfJudgmentDalnevostochniy = () => {
  const judgment = RuntimeConfig.APP_PROF_JUDGMENT;
  return !judgment ? false : judgment === "prof_judgment_dvx";
};

export const IsProfJudgmentCreditAnalysis = () => {
  const judgment = RuntimeConfig.APP_PROF_JUDGMENT;
  return !judgment ? false : judgment === "prof_judgment_fsx";
}

export const IsPublicRatingV2 = (): boolean => RuntimeConfig.APP_PUBLIC_RATING === "int_rating";

export const ShouldHideUserEdit = (): boolean =>
  RuntimeConfig.APP_HIDE_USER_EDIT !== undefined
    ? RuntimeConfig.APP_HIDE_USER_EDIT
    : RuntimeConfig.APP_KEYCLOAK_AUTH_ENABLED;

export const REACT_APP_BACKEND_URL = (): string =>
  RuntimeConfig.APP_BACKEND_URL;
export const APP_KEYCLOAK_AUTH_AUTHORITY = (): string =>
  RuntimeConfig.APP_KEYCLOAK_AUTH_AUTHORITY;
export const APP_KEYCLOAK_CLIENT_ID = (): string =>
  RuntimeConfig.APP_KEYCLOAK_CLIENT_ID;
export const APP_DOCS_URL = (): string => RuntimeConfig.APP_DOCS_URL ?? "";

export const loadRuntimeConfig = async () => {
  const res = await fetch("/config.json", { cache: "no-cache" });
  RuntimeConfig = await res.json();
};
